import { Box, Button, Grid, InputAdornment, Stack, TextField } from '@mui/material';
import { useState } from 'react';
import { UserAndConversations } from 'src/models/userAndConversations';
import { PureLightTheme } from 'src/theme/schemes/PureLightTheme';
import SearchIcon from '@mui/icons-material/Search';

function TextFieldPlayers({ searchText, setSearchText }) {
  const handleSearchTextChange = (event) => {
    setSearchText(event.target.value);
  };

  return (
    <Grid container justifyContent="center" spacing={2}>
      <Grid item xs={12}>
        <Box bgcolor={PureLightTheme.palette.background.default}>
          <Stack direction={{ xs: 'row', lg: 'row' }} justifyContent={{ xs: 'center', lg: 'center' }} alignItems="center">
            <TextField
              id="outlined-basic"
              label="Search players"
              variant="outlined"
              color="info"
              value={searchText}
              onChange={handleSearchTextChange}
              InputProps={{
                endAdornment: <SearchIcon />,
                style: { color: PureLightTheme.colors.alpha.white[70], height: '35px' }
              }}
              sx={{ width: '300px' }}
            />
          </Stack>
        </Box>
      </Grid>
    </Grid>
  );
}

export default TextFieldPlayers;
